import { defineMessages } from '@dragonraider5/react-intl'

export default defineMessages({
  rootLinkTitle: {
    id: 'containers.App.Header.links.root.title',
    description: 'App root title',
    defaultMessage: 'Canal digital de solicitud de financiación para empresas y autónomos'
  },
  loginLink: {
    id: 'containers.Login.LoginLink',
    description: 'Login link text',
    defaultMessage: 'Iniciar sesión'
  },
  logoutButton: {
    id: 'containers.Login.LogoutButton',
    description: 'Logout button text',
    defaultMessage: 'Cerrar sesión'
  },
  mainBannerTitle: {
    id: 'containers.App.MainBanner.title',
    description: 'Main Banner Title',
    defaultMessage: 'Solicitud digital de financiación para empresas y autónomos'
  },
  callToActionTitle: {
    id: 'containers.App.CallToAction.title',
    description: 'App call to action title',
    defaultMessage: '¿Tienes alguna duda?'
  },
  callToActionText: {
    id: 'containers.App.CallToAction.text',
    description: 'App call to action text',
    defaultMessage: 'Llama o escríbenos'
  },
  callToActionButton: {
    id: 'containers.App.CallToAction.button',
    description: 'App call to action button',
    defaultMessage: 'Contactar'
  },
  socialNavTitle: {
    id: 'containers.App.Footer.SocialNav.title',
    description: 'App footer Social Nav title',
    defaultMessage: 'Síguenos en'
  },
  socialNavLinkTitle: {
    id: 'containers.App.Footer.SocialNav.links.title',
    description: 'App footer Social Nav link title',
    defaultMessage: 'Síguenos en {name}'
  },
  privacyLink: {
    id: 'containers.App.privacyLink',
    description: 'Privacy link text and title',
    defaultMessage: 'Política de privacidad'
  },
  legalLink: {
    id: 'containers.App.legalLink',
    description: 'Legal link text and title',
    defaultMessage: 'Aviso legal y seguridad'
  },
  contact: {
    id: 'containers.App.contactLink',
    description: 'Contact link text and title',
    defaultMessage: 'Contactanos'
  }
})
